import '../slim.jquery';

$(document).ready(function($){

    var url = $('base').attr('href');

    M.AutoInit();

    $(window).on("scroll", function() {
        100 < $(window).scrollTop() ? $("header").addClass("menu-fixed") : $("header").removeClass("menu-fixed")
    })

    $('.select2').select2();

    var TelMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
      },
      spOptions = {
        onKeyPress: function(val, e, field, options) {
            field.mask(TelMaskBehavior.apply({}, arguments), options);
          }
      };
    

    $('#cep').mask('00000-000');
    $('#cnpj').mask('00.000.000/0000-00');
    $('#cpf').mask('000.000.000-00');
    $('#telefone').mask(TelMaskBehavior, spOptions);
    $('#telefone_imobiliaria').mask(TelMaskBehavior, spOptions);
    $('#telefone_gestor').mask(TelMaskBehavior, spOptions);

    $('.user-image').slim({
        ratio: '1:1',
        minSize: {
            width: 400,
            height: 400,
        },
        download: false,
        label: '<i class="material-icons">image</i> <br />Imagem perfil',
        buttonConfirmLabel: 'Ok',
    });

    $('.imobiliaria-image').slim({
        ratio: '1:1',
        minSize: {
            width: 400,
            height: 400,
        },
        download: false,
        label: '<i class="material-icons">image</i> <br />Imagem imobiliária',
        buttonConfirmLabel: 'Ok',
    });

    
     /* BUSCA DE ENDERECO POR CEP */
     $('#cep').keyup(function() {
        var cep = $(this).val().replace(/[^\d]+/g,'');
        if(cep.length == 8){
            var verify = $.trim(cep);
            $.ajax({
                url: url+"/getCep/"+verify,
                dataType: 'json',
                type: 'GET',
                success: function(resultadoCEP) {

                if(resultadoCEP.status){
                    $("#estado_imobiliaria").val(resultadoCEP['estado_id']).select2();
                    resultadoCEP['cidades'].forEach(function(e, i){
                        $('select#cidade_imobiliaria').append($('<option><option/>').val(e.id).text(e.nome)); 
                    });
                    $("select#cidade_imobiliaria").val(resultadoCEP['cidade_id']);
                    $('input[name="dados[imobiliaria][endereco]"]').val(unescape(resultadoCEP["tipo_logradouro"]) + " " + unescape(resultadoCEP["logradouro"])).next().addClass('active');
                } 
                },
                error: function(xhr, ajaxOptions, thrownError) {
                }
            });
        }
    });

    //Estados e cidades
    $(function(){
        $('select[name="estado_id"]').change(function(){
            if( $(this).val() ) {
                $.getJSON(url+'/getCidades/'+$(this).val(), function(j){
                    var options = '<option value="">Selecione a cidade</option>';
                    for (var i = 0; i < j.length; i++) {
                    options += '<option value="' + j[i].id + '">' + j[i].nome + '</option>';
                    }
                    $('select[name="cidade_id"]').html(options);
                });
            } 
        });
    });
    
    if( $('#estado option:selected').val()) {
        var val = $('#estado option:selected').val();
        $.getJSON(url+'/getCidades/'+ val, function(j){
            var options = '<option value=""></option>';
            for (var i = 0; i < j.length; i++) {
            options += '<option value="' + j[i].id + '"' + ( j[i].id == $('#cidade').data('cidade') ? "selected" : "" ) + '>' + j[i].nome + '</option>';
            }
            $('#cidade').html(options);
        });
    }

    //Estados e cidades Imobiliaria
    $(function(){
        $('#estado_imobiliaria').change(function(){
            if( $(this).val() ) {
                $.getJSON(url+'/getCidades/'+$(this).val(), function(j){
                    var options = '<option value="">Selecione a cidade</option>';
                    for (var i = 0; i < j.length; i++) {
                    options += '<option value="' + j[i].id + '">' + j[i].nome + '</option>';
                    }
                    $('#cidade_imobiliaria').html(options);
                });
            } 
        });
    });
    
    if( $('#estado_imobiliaria option:selected').val()) {
        var val = $('#estado_imobiliaria option:selected').val();
        $.getJSON(url+'/getCidades/'+ val, function(j){
            var options = '<option value=""></option>';
            for (var i = 0; i < j.length; i++) {
            options += '<option value="' + j[i].id + '"' + ( j[i].id == $('#cidade_imobiliaria').data('cidade') ? "selected" : "" ) + '>' + j[i].nome + '</option>';
            }
            $('#cidade_imobiliaria').html(options);
        });
    }


});